export const CO_DOCUMENT_LENGTHS: Record<string, { min: number; max: number }> =
  {
    CC: { min: 6, max: 10 },
    CE: { min: 8, max: 16 },
    Pasaporte: { min: 8, max: 9 },
  };

export const getCODocumentLength = (
  taxtype: string,
): { min: number; max: number } | undefined => CO_DOCUMENT_LENGTHS[taxtype];

export const isValidCODocument = (value: string, taxtype: string): boolean => {
  const length = CO_DOCUMENT_LENGTHS[taxtype];
  if (!length) {
    return false;
  }

  const cleaned =
    taxtype === 'Pasaporte' ? value.trim() : value.replace(/\D/g, '');

  return cleaned.length >= length.min && cleaned.length <= length.max;
};
